/* SVADEZI — sticky buy bar trigger.

   WAS: theme.js observed the HERO with rootMargin '-40% 0px 0px 0px', so the
   bar slid up once the gallery was ~40% scrolled — while the real Add to Bag
   button was often still on screen. Two Add-to-bag controls visible at once.

   NOW: observe the main Add to Bag button itself. The bar appears only after
   that button has scrolled off the top, and hides again when it returns —
   which is what the brand app does and what was asked for.

   Runs after theme.js and takes over: it clears the class theme.js may have
   set, then drives .is-on from its own observer. */
(function () {
  var bar = document.querySelector('[data-pdp-sticky], .pdp-sticky');
  if (!bar) return;

  // the real Add to Bag lives in the buy box; the sticky one is inside `bar`
  var atc = null;
  var candidates = document.querySelectorAll(
    '.pdp-cta button[type="submit"], .pdp-addtocart, form[action*="/cart/add"] button[type="submit"]'
  );
  for (var i = 0; i < candidates.length; i++) {
    if (!bar.contains(candidates[i])) { atc = candidates[i]; break; }
  }
  var anchor = atc || document.querySelector('.pdp-cta');
  if (!anchor) return;

  if (!('IntersectionObserver' in window)) return;

  var show = function (on) { bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); };

  // Only reveal once the button has left through the TOP of the viewport.
  // boundingClientRect.top < 0 distinguishes "scrolled past" from
  // "still below the fold", so the bar never appears on first paint.
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
      show(scrolledPast);
    });
  }, { threshold: 0, rootMargin: '0px' }).observe(anchor);

  show(false);
})();
